import { jsx as _jsx } from "react/jsx-runtime";
import EndFiscalYearMultiSelect from '../multiselect/EndFiscalYearMultiSelect';
export const FilterEndFiscalYearMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(EndFiscalYearMultiSelect, { selection: activeFilters[item], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }) })),
});
